import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getReasonsKiosks(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Vývoj kioskové aplikace na míru",
			desc: "Nezáleží, v jakém odvětví podnikáte. Zvládneme vytvořit objednávkový kiosek do restaurace, navigační kiosek do skladu nebo informační terminál na veřejné místo.",
		},
		{
			title: "Pomoc s provozováním kiosku",
			desc: "Po dokončení vývoje vás nenecháme ve štychu. Pomůže vám kiosek provozovat a rádi provedeme i důkladné zaškolení.",
		},
		{
			title: "Napojení potřebných periferií",
			desc: "Kioskovou aplikací to nekončí. Pokud budete chtít, připojíme ke kiosku periferie jako platební terminál, tiskárnu účtenek nebo kameru.",
		},
		{
			title: "Dodání kioskového hardwaru",
			desc: "Díky spolupráci s partnery pro vás dokážeme výhodně zajistit i hardware kioskového řešení. Můžete od nás tedy dostat jak aplikaci na míru, tak fyzický kiosek.",
		},
		{
			title: "Aktualizace bez výpadku",
			desc: "Nikdo nechce, aby jeho kiosek stál kvůli aktualizaci systému. Proto se postaráme o to, aby byly aktualizace prováděny bez výpadku služeb.",
		},
		{
			title: "Vzdálená správa kiosků",
			desc: "Ke kioskům vám zvládneme vyvinout systém na správu vaší kioskové sítě, nebo napojit na vaše stávající řešení.",
		},
	];
}
